/**
 * Utilities: Options
 *
 * @module utility/UOptions
 * @example import { UOptions } from '../common/utility/u-options';
 */


/**
 * Parse a JSON options string from an element. Returns an object (or the
 * provided defaults object)
 *
 * @todo: Update `setupComponentOptions` to use this ƒ instead
 * (src/assets/js-webpack/common/internal/i-component-setup.js)
 *
 * @example UOptions.parseOptions( $container, 'data-my-options', defaultsArr, 'name-for-logging' );
 *
 * @param   {jQuery}   $container      jQuery container element (which has the data attribute)
 * @param   {string}   dataAttr        Component's data attribute (eg "data-c-example")
 * @param   {object}   defaultOpts     Default options object. Can be an empty object if the component has no options
 * @param   {string}   name            Component name (eg "example"). Only used for logging
 * @param   {boolean}  throwException  True to throw an error if the JSON fails to parse. Must be caught in the caller ƒ
 *
 * @return  {Object}   Options object parsed from the JSON, or the default options object if any issues occured (eg. error or empty options string)
 */
function parseOptions( $container, dataAttr, defaults = {}, name, throwException = false )
{
	const logPrefix = `[parseOptions:${name}] `;
	const debugLog = false;

	// ErrorTracker
	let ET = {
		msg: '',
		hasError: false,
		errorObj: null,
	};

	if ( !$container || !$container.length )
	{
		ET.msg = 'Container was not found';
		ET.hasError = true;
	}

	if ( !ET.hasError && typeof $container.attr( dataAttr ) === undefined )
	{
		ET.msg = `Container does not have the target data attribute (${dataAttr})`;
		ET.hasError = true;
	}

	if ( !ET.hasError )
	{
		const customOptionsStr = $container.attr( dataAttr );

		// Data attr string was empty, ie. no options were set
		if ( !customOptionsStr || customOptionsStr === '' )
		{
			if ( debugLog )
			{
				console.info( logPrefix + 'Options string was empty!' ); //@debug
			}

			return defaults;
		}

		// Attempt JSON parse
		try
		{
			const options = defaults;
			const parsedData = JSON.parse( customOptionsStr );

			Object.assign( options, parsedData );

			if ( debugLog )
			{
				console.info( logPrefix + 'Parsed options:', parsedData ); //@debug
			}

			return options;
		}
		catch( err )
		{
			console.log('PARSE_FAIL');
			ET.msg = `Failed to parse custom options. Please check that the options string is valid JSON`;
			ET.hasError = true;
			ET.errorObj = err;
		}
	}

	if ( ET.hasError )
	{
		ET.msg = logPrefix + ET.msg;

		if ( throwException )
		{
			if ( ET.errorObj )
			{
				throw { message: ET.msg,error: ET.errorObj };
			}
			else
			{
				throw ET.msg;
			}
		}
		else
		{
			console.warn( ET.msg + '\n(See next message for data)' );
			console.warn( { name, $container, dataAttr, defaults } );

			if ( ET.errorObj )
			{
				console.warn( ET.errorObj );
			}

			return defaults;
		}
	}
}

export const UOptions = { parseOptions };
